import React from 'react';

import PropTypes from 'prop-types';

import { cn } from '@/lib/utils';
import { BADGE_COLORS } from '../../../../../../../shared/components/Tag';
import { formatTimeRange } from '../../../../../utils';
import { ACCENT_COLORS } from '../../constants';

const Appointment = ({ color, endAt, onClick, startAt, title }) => {
  const containerStyles = cn(
    'flex flex-col w-full gap-0.5 rounded-r border-l-4 px-2 py-1 overflow-hidden',
    ACCENT_COLORS[color],
    BADGE_COLORS[color]
  );

  return (
    <div className={containerStyles} onClick={onClick}>
      <span className="text-[11px] font-semibold truncate">{title}</span>

      <span className="text-[10px] tabular-nums opacity-80 truncate">
        {formatTimeRange({ endAt, startAt })}
      </span>
    </div>
  );
};

Appointment.propTypes = {
  color: PropTypes.string.isRequired,
  endAt: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  startAt: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default Appointment;
